import { useTranslations } from '@vocab/react';
import { useMemo } from 'react';

import {
  CAREER_HISTORY,
  SKILLS,
  RESUME,
  SUMMARY,
  PERSONAL_DETAILS,
  NEXT_ROLE,
  PROFILE_VISIBILITY,
  EDUCATION,
  LICENCES,
  LANGUAGES,
  CREATE_RESUME,
  PROFILE_VISIBILITY_V2,
  SHAREABLE_PROFILE,
} from 'src/components/Router';

import translations from './.vocab';

export const useParentTitles = (): Record<string, string> => {
  const { t } = useTranslations(translations);

  return useMemo(
    () => ({
      [CAREER_HISTORY]: t('Career history'),
      [SKILLS]: t('Skills'),
      [RESUME]: t('Resumé'),
      [SUMMARY]: t('Summary'),
      [PERSONAL_DETAILS]: t('Personal details'),
      [NEXT_ROLE]: t('Next role'),
      [PROFILE_VISIBILITY]: t('Profile visibility'),
      [EDUCATION]: t('Education'),
      [LICENCES]: t('Licences'),
      [LANGUAGES]: t('Languages'),
      [CREATE_RESUME]: t('Create resumé'),
      ['next-role-availability']: t('Availability'),
      ['next-role-work-types']: t('Preferred work types'),
      ['next-role-approachability']: t('Approachability'),
      ['next-role-salary']: t('Salary expectation'),
      ['next-role-right-to-work']: t('Right to work'),
      ['next-role-classification']: t('Preferred classification'),
      ['next-role-preferred-locations']: t('Preferred location'),
      [PROFILE_VISIBILITY_V2]: t('Profile visibility'),
      [SHAREABLE_PROFILE]: t('Profile visibility'),
    }),
    [t],
  );
};
